export default "/img_count_1.png";